import { render, staticRenderFns } from "./AppointmentOverview.vue?vue&type=template&id=397fdb8d&scoped=true"
import script from "./AppointmentOverview.vue?vue&type=script&lang=js"
export * from "./AppointmentOverview.vue?vue&type=script&lang=js"
import style0 from "./AppointmentOverview.vue?vue&type=style&index=0&id=397fdb8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397fdb8d",
  null
  
)

export default component.exports